import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CALENDLY_URL } from '@constants';
import { NodeGraphBackground } from '@components/common';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-primary pt-16">
      {/* Node-network background — the brand motif rendered live, matching the social card. */}
      <NodeGraphBackground />

      <div className="container-custom relative z-10 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge with float animation */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal/10 border border-teal/20 mb-6 animate-fade-in float-subtle cursor-default hover:bg-teal/20 hover:border-teal/40 transition-all duration-300">
            <h1 className="text-sm font-medium text-teal tracking-wide">
              <em>The</em> Fractional CISO Platform
            </h1>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-foreground leading-tight tracking-tight mb-6 animate-fade-up">
            World-Class Cyber Security Leadership,{' '}
            <span className="text-gradient-teal">Without the Full-Time Cost</span>
          </h2>

          <p
            className="text-lg md:text-xl text-primary-foreground/70 mb-10 max-w-3xl leading-relaxed animate-fade-up"
            style={{ animationDelay: '0.1s' }}
          >
            Access experienced Chief Information Security Officers who embed in your business - able
            to scale to your needs whether part-time, interim, augmenting your existing CISO or as a
            full-time CISO service. Collective intelligence that provides strategic security
            leadership tailored to your growth stage.
          </p>

          <div
            className="flex flex-col sm:flex-row gap-4 opacity-0"
            style={{
              animation: 'fade-up 0.6s ease-out forwards',
              animationDelay: '0.2s',
            }}
          >
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-hero magnetic-hover group"
            >
              Book a Call
              <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <Link to="/services" className="btn-hero-outline magnetic-hover">
              Learn More
            </Link>
          </div>

          {/* Trust indicators */}
          <div
            className="mt-16 flex flex-wrap gap-8 items-center animate-fade-up"
            style={{ animationDelay: '0.3s' }}
          >
            {[
              { label: 'Operational Resilience' },
              { label: 'Regulatory Confidence' },
              { label: 'Enabling Growth' },
            ].map(item => (
              <div key={item.label} className="flex items-center gap-2 text-primary-foreground/60">
                <div className="w-2 h-2 rounded-full bg-teal" />
                <span className="text-sm">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
